import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import {
  FiltersClearButton,
  FiltersClearButtonStyles,
} from '../../../../../../../components/Filters/components/FiltersClearButton';

import { EmptyBlock } from '../../../../../../../components/Filters/components/EmptyBlock';

import type { IEmptyFlights } from '../types';

/**
 * Блок отображается, если на чекауте ни один перелет не попал под фильтры
 */
export const EmptyFlights: FC<IEmptyFlights> = ({ clearFilters }) => {
  const { t } = useTranslation();
  return (
    <EmptyBlock>
      <Title> {t('checkout.flight.empty.title')}</Title>
      <Text>{t('checkout.flight.empty.text')}</Text>
      <RemoveFiltersButton onClick={clearFilters} />
    </EmptyBlock>
  );
};

const Title = styled.span`
  font-weight: bold;
  font-size: 28px;
  line-height: 34px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 20px;
  width: 500px;
  color: #4d4d4d;
  margin: 8px 0px 16px;
  text-align: center;
`;

const RemoveFiltersButton = styled(FiltersClearButton)`
  font-size: 16px;
  line-height: 20px;
  width: 220px;
  height: 48px;
  color: #007aff;
  border-color: #007aff;

  ${FiltersClearButtonStyles.Icon} {
    stroke: #007aff;
  }
`;
